<template>
  <v-card flat width="100%" class="card-dias-planta-abate">
    <v-container
      fluid
      class="pa-0"
    >
      <v-row
        class="ma-0"
      >
        <v-col
          cols="6"
          class="pa-2 d-flex flex-column"
        >
          <v-row class="ma-0 d-flex flex-column flex-fill">
            <span class="label-card-dados-planta">Alocados</span>
            <span class="value-card-dados-planta">{{ qtTotalAnimaisAlocadoDia }}</span>
          </v-row>
          <v-row class="ma-0 d-flex flex-column flex-fill">
            <span class="label-card-dados-planta">Carregamentos</span>
            <span class="value-card-dados-planta">{{ nrCarregamentos }}</span>
          </v-row>
        </v-col>
        <v-col
          cols="6"
          class="pa-2 d-flex flex-column"
        >
          <v-row class="ma-0 d-flex flex-column flex-fill">
            <span class="label-card-dados-planta">Peso Médio</span>
            <span class="value-card-dados-planta kg">{{ nrPesoMedioDia }}</span>
          </v-row>
          <v-row class="ma-0 d-flex flex-column flex-fill">
            <span class="label-card-dados-planta">Distância total</span>
            <span
              class="value-card-dados-planta"
              :class="[{
                'km': nrDistanciaTotal !== '-'
              }]"
            >{{ nrDistanciaTotal }}</span>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import {daysBetweenDates} from "@/filters/utils"

export default {
  name: "CardItemInicialDataCarregamentoPlanta",
  props: {
    itemData: {
      type: Object,
      default: {},
    },
    itemPlanta: {
      type: Object,
      default: {},
    },
    listaLotesFiltradaDataPlanta: {
      type: Object,
    },
  },
  computed: {
    qtTotalAnimaisAlocadoDia() {
      let listPreenchida = []
      for (const key in this.listaLotesFiltradaDataPlanta) {
        let itemsData = this.listaLotesFiltradaDataPlanta[key][
          this.itemData.text
          ]
        itemsData.forEach((lote) => {
          listPreenchida.push(lote)
        })
      }
      let total = 0
      listPreenchida.forEach(function (item) {
        total = (parseInt(total) | 0) + (parseInt(item.qtAnimaisAlocados) | 0)
      })
      return total
    },
    nrPesoMedioDia() {
      let listPreenchida = []
      for (const key in this.listaLotesFiltradaDataPlanta) {
        let itemsData = this.listaLotesFiltradaDataPlanta[key][
          this.itemData.text
          ]
        itemsData.forEach((lote) => {
          listPreenchida.push(lote)
        })
      }
      let pesoTotal = 0
      let qtItems = 0
      let nrPesoMedio = 0
      listPreenchida.forEach(function (item) {
        if (item.nrPesoDia) {
          pesoTotal = pesoTotal + item.nrPesoDia
          qtItems = qtItems + 1
          nrPesoMedio = (pesoTotal / qtItems).toFixed(1)
        }
      })
      return nrPesoMedio
    },
    nrDistanciaTotal() {
      let listPreenchida = []
      for (const key in this.listaLotesFiltradaDataPlanta) {
        let itemsData = this.listaLotesFiltradaDataPlanta[key][
          this.itemData.text
          ]
        itemsData.forEach((lote) => {
          listPreenchida.push(lote)
        })
      }
      let nrDistancia = 0
      listPreenchida.forEach(function (item) {
        if (item.distanciaPlanta) {
          if (item.distanciaPlanta.nrValor != "-") {
            nrDistancia =
              nrDistancia + (parseInt(item.distanciaPlanta.nrValor) | 0)
          } else {
            nrDistancia = nrDistancia + 0
          }
        }
      })
      return nrDistancia
    },
    nrCarregamentos() {
      let listPreenchida = []
      for (const key in this.listaLotesFiltradaDataPlanta) {
        let itemsData = this.listaLotesFiltradaDataPlanta[key][
          this.itemData.text
          ]
        itemsData.forEach((lote) => {
          listPreenchida.push(lote)
        })
      }
      return listPreenchida.length
    },
  },
  methods: {
    daysBetweenDates,
  },
}
</script>
